import React, { Fragment, lazy, Suspense } from "react";
import MasterLayout from "../components/masterLayout/Master-Layout";
import LazyLoader from "../components/masterLayout/LazyLoader";
const Canceled = lazy(() => import("../components/Cenceled/Cenceled"));
const CanceledPage = () => {
  return (
    <Fragment>
      <MasterLayout>
        <Suspense fallback={<LazyLoader />}>
          <Canceled />
        </Suspense>
      </MasterLayout>
    </Fragment>
  );
};

export default CanceledPage;
